"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSandboxMeetingObject = getSandboxMeetingObject;
var _amazonChimeSdkJs = require("amazon-chime-sdk-js");
var _constants = require("../constants");
function getSandboxMeetingObject(meetingResponse, attendeeResponse) {
  var logger = new _amazonChimeSdkJs.ConsoleLogger(_constants.loggerName, _amazonChimeSdkJs.LogLevel.WARN);
  var deviceController = new _amazonChimeSdkJs.DefaultDeviceController(logger);
  var configuration = new _amazonChimeSdkJs.MeetingSessionConfiguration(meetingResponse, attendeeResponse);
  var meetingSession = new _amazonChimeSdkJs.DefaultMeetingSession(configuration, logger, deviceController);
  return {
    meetingSession: meetingSession,
    logger: logger
  };
}